import React, { useState } from 'react';
import './supplyChainFinance.scss';
import PainPointsAsea from '../../assets/supplyChainFinance_images/ache_1.png';
import PainPointBaa from '../../assets/supplyChainFinance_images/ache_2.png';
import PainPointsDeaIm from '../../assets/supplyChainFinance_images/ache_3.png';
import imgApplicableOne from '../../assets/supplyChainFinance_images/excellent_1.png';
import imgApplicableTwo from '../../assets/supplyChainFinance_images/excellent_2.png';
import imgApplicableThree from '../../assets/supplyChainFinance_images/excellent_3.png';
import imgApplicableFour from '../../assets/supplyChainFinance_images/excellent_4.png';
import imgApplicableOneBright from '../../assets/supplyChainFinance_images/excellent_1_2.png';
import imgApplicableTwoBright from '../../assets/supplyChainFinance_images/excellent_2_2.png';
import imgApplicableThreeBright from '../../assets/supplyChainFinance_images/excellent_3_2.png';
import imgApplicableFourBright from '../../assets/supplyChainFinance_images/excellent_4_2.png';
import productImgSua from '../../assets/supplyChainFinance_images/product_1.png';
import productImagAfs from '../../assets/supplyChainFinance_images/product_2.png';
import productImagJek from '../../assets/supplyChainFinance_images/product_3.png';
import productImageTop from '../../assets/supplyChainFinance_images/product_4.png';
import productImageSta from '../../assets/supplyChainFinance_images/product_5.png';
import productImageWan from '../../assets/supplyChainFinance_images/product_6.png';
import angryLittleGirl from '../../assets/angryLittleGirl.png';

const supplySoftwareIntroductionText =
  '挚云数科供应链金融系统借助互联网、大数据征信、人工智能等信息技术，依托于核心企业的交易过程，以中小企业的订单、物流、融资、仓储等经营性行为，作为融资手段，通过交易数据提取及分析，实现授信及融资；系统以场景+金融为出发点，支持供应链业务中不同业务形态需求。同时系统可对接多种平台服务，保障系统的智能、安全、高效运行。';

const applicableScenarios = [
  { img: productImgSua, text: '产品灵活快速配置' },
  { img: productImagAfs, text: '技术架构便于后期运维' },
  { img: productImagJek, text: '安全稳定的操作系统' },
  { img: productImageTop, text: '上线部署快' },
  { img: productImageSta, text: '配套接口齐全' },
  { img: productImageWan, text: '微服务架构拓展性强' },
];
const industryPainPointsList = [
  {
    title: '资金方',
    img: PainPointsAsea,
    textAll: ['客户资源少', '获客效率低', '运营成本高', '客户资信风险高'],
  },
  {
    title: '核心企业',
    img: PainPointBaa,
    textAll: [
      '资金流有限',
      '信誉难以变现',
      '贷款申请手续繁琐',
      '账期长',
      '上下游供应链不稳定',
    ],
  },
  {
    title: '上下游企业',
    img: PainPointsDeaIm,
    textAll: [
      '征信方式单一',
      '融资难',
      '债权债务处理难',
      '社会信誉低',
      '线下提交融资资料',
      '效率低',
    ],
  },
];

const SupplyChainFinance = () => {
  const systemItem = {
    color: '#fff',
    backgroundSize: 'cover',
  };

  const [supplyShow, setSupplyShow] = useState(null);
  const [systemAdvantages, setSystemAdvantages] = useState([
    {
      id: 1,
      supplyShow: true,
      img: imgApplicableOne,
      imgBright: imgApplicableOneBright,
      title: '金融信贷',
      text: '核心技术团队均来自银行、商业保理、供应链金融、融资租赁、融资担保等行业，都拥有多年的类金融实战经验',
    },
    {
      id: 2,
      supplyShow: true,
      img: imgApplicableTwo,
      imgBright: imgApplicableTwoBright,
      title: '智能风控',
      text: '系统已对接了多渠道风控数据形成成熟强大的风控模型和引擎。利用大数据进行决策分析',
    },
    {
      id: 3,
      supplyShow: true,
      img: imgApplicableThree,
      imgBright: imgApplicableThreeBright,
      title: '科技体系',
      text: '系统搭载了先进的技术体系、将AI、区块链等先进的技术运用到实际的项目当中',
    },
    {
      id: 4,
      supplyShow: true,
      img: imgApplicableFour,
      imgBright: imgApplicableFourBright,
      title: '解决方案',
      text: '实现多行业多场景多保理类型解决方案、为供应链金融提供一站式解决方案',
    },
  ]);
  const handleMouseEnter = (id) => {
    setSupplyShow(id);
  };
  const handleMouseLeave = () => {
    setSupplyShow(null);
  };

  return (
    <div className="supply-chainFinance">
      <div className="supply-software">
        <div className="supply-title-weight">
          <div className="title-ch">供应链金融系统软件介绍</div>
          <div className="title-en">
            INTRODUCTION TO SUPPLY CHAIN FINANCE SYSTEM SOFTWARE
          </div>
          <div className="horizontal-line" />
        </div>
        <div className="supply-software-introduction">
          <div className="supply-software-introduction-img">
            <img src={angryLittleGirl} alt="" />
          </div>
          <div className="supply-software-introduction-text">
            {supplySoftwareIntroductionText}
          </div>
        </div>
      </div>
      <div className="supply-discoloration">
        <div className="industry-pain-points">
          <div className="supply-title-weight" style={{ marginTop: 50 }}>
            <div className="title-ch">行业痛点</div>
            <div className="title-en">INDUSTRY PAIN POINTS</div>
            <div className="horizontal-line" />
          </div>
          <div className="supply-industry">
            {industryPainPointsList.length > 0 &&
              industryPainPointsList.map((item, ind) => {
                return (
                  <dl className="supply-industry-dl" key={ind}>
                    <dt className="supply-industry-dt">
                      <img src={item.img} alt="" />
                    </dt>
                    <dd className="supply-industry-dd-title">{item.title}</dd>
                    <dd className="supply-industry-dd-text">
                      {item.textAll.map((v, i) => (
                        <span key={i}>{v}</span>
                      ))}
                    </dd>
                  </dl>
                );
              })}
          </div>
        </div>
        <div className="system-advantages">
          <div className="supply-title-weight">
            <div className="title-ch">系统优势</div>
            <div className="title-en">SYSTEM ADVANTAGES</div>
            <div className="horizontal-line" />
          </div>
          <div className="supply-system">
            {systemAdvantages.length > 0 &&
              systemAdvantages.map((item) => {
                return (
                  <dl
                    className="system-industry-dl"
                    key={item.id}
                    onMouseEnter={() => handleMouseEnter(item.id)}
                    onMouseLeave={() => handleMouseLeave(item.id)}
                    style={supplyShow === item.id ? systemItem : null}
                  >
                    <div className="system-industry-ding" />
                    <dt className="system-industry-dt">
                      <img
                        src={supplyShow === item.id ? item.imgBright : item.img}
                        alt=""
                      />
                    </dt>
                    <dd className="system-industry-title">{item.title}</dd>
                    <dd className="system-industry-text">{item.text}</dd>
                  </dl>
                );
              })}
          </div>
        </div>
      </div>
      <div className="supply-software">
        <div className="supply-title-weight">
          <div className="title-ch">适用场景</div>
          <div className="title-en">APPLICABLE SCENARIOS</div>
          <div className="horizontal-line" />
        </div>
        <div className="supply-scene">
          {applicableScenarios.length > 0 &&
            applicableScenarios.map((item, ind) => {
              return (
                <dl key={ind}>
                  <dt>
                    <img src={item.img} alt="" />
                  </dt>
                  <dd>{item.text}</dd>
                </dl>
              );
            })}
        </div>
      </div>
    </div>
  );
};

export default SupplyChainFinance;
